import { render, staticRenderFns } from "./Ireland.vue?vue&type=template&id=5b90cb22&"
import script from "./Ireland.vue?vue&type=script&lang=ts&"
export * from "./Ireland.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports